import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SeasonPlan } from '@coin/shared/core/util-models';
import { Store } from '@ngxs/store';
import { SeasonState } from '../../../season-mgmt/store';

@Component({
  selector: 'admin-select-plan-dialog',
  templateUrl: './select-plan-dialog.component.html',
  styleUrls: ['./select-plan-dialog.component.scss'],
  standalone: false
})
export class SelectPlanDialogComponent {
  data = inject<{
    value: SeasonPlan;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<SelectPlanDialogComponent>>(MatDialogRef);
  private store = inject(Store);

  plans$ = this.store.select<SeasonPlan[]>(SeasonState.plans);

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.data.value);
  }

  displayFn(plan: SeasonPlan): string {
    return plan.title;
  }

  compare(planOne: SeasonPlan, planTwo: SeasonPlan): boolean {
    return planOne?.id === planTwo?.id;
  }
}
